import dashboard from './dashboard';
import utilities from './utilities';
import family from './family';
// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [dashboard, family, utilities]
};

export default menuItems;
